


















































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import { InternalReferralUserInfo } from '../../models/referrals/internalReferralUserInfo';
import { ReferredUserAddress } from '../../models/referrals/referredUserAddress';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

@Component({
  name: 'InternalRefUserForm',
  components: {
    VueGoogleAutocomplete,
  },
  data() {
    return {
      options: [{ value: '1', text: 'USA (+1)' }],
    };
  },
})
export default class UserForm extends Vue {
  private nameRegex: RegExp = new RegExp("^[a-zA-Z-, ']+$");
  private candidatePhone: string = '';
  private noExample: boolean = true;
  private specialityType = 0;
  private referredUserAddress: ReferredUserAddress = new ReferredUserAddress();
  @Prop({ default: new InternalReferralUserInfo() }) userInfo;

  mounted() {
    if (vxm.users.isLoggedIn) vxm.referrals.fetchSpecialityList();
    else {
      vxm.referrals.fetchInternalSpecialityList();
    }
  }

  getChar(event): string {
    return String.fromCharCode(event.charCode ? event.charCode : event.which);
  }

  updateCandidatePhone(event) {
    console.log(
      'Number is :  ',
      '+' + event.countryCallingCode + ' ' + event.nationalNumber,
    );
    this.userInfo.phoneNumber =
      '+' + event.countryCallingCode + ' ' + event.nationalNumber;
    this.userInfo.phoneNumberValid = event.isValid;
  }

  getPastedData(event): string {
    return event.clipboardData.getData('text/plain');
  }

  getCompanyCountryCode(): string {
    return vxm.jobs.getCompanyCountryCode;
  }

  get specialityList() {
    return vxm.referrals.getSpecialityList;
  }

  getAddressData(addressData, placeResultData, id) {
    console.log(addressData);
    this.userInfo.addressInfo.city = addressData.locality;
    this.userInfo.addressInfo.state = addressData.administrative_area_level_1;
    this.userInfo.addressInfo.country = addressData.country;
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }
}
